import routes from 'sitewide-js/core_pre_webpack/routes';
import { fetchWithCsrf } from 'js/utils';
import { Image } from 'js/social/shared/types';

export async function uploadImage(image: File): Promise<Image> {
  const formData = new FormData();
  formData.append('image', image);

  const response = await fetchWithCsrf(
    routes.api_v0_community_image_path({
      subdomain_param: 'api',
    }),
    {
      method: 'POST',
      body: formData,
    },
  );
  if (!response.ok) {
    let error: string;
    try {
      error = (await response.json()).error;
    } catch {
      error = `Couldn't upload your image. Please try again.`;
    }
    throw new Error(error);
  }
  return (await response.json()).image;
}
